import { render, staticRenderFns } from "./RoomReservationNavBar.vue?vue&type=template&id=2ed3d1bb"
import script from "./RoomReservationNavBar.vue?vue&type=script&lang=js"
export * from "./RoomReservationNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports